import React from "react";
import Head from "next/head";
import { usePathname, useSearchParams } from "next/navigation";
import { parse } from "qs";

import useDomain from "@/hooks/useDomain";

import createPaginationUrl from "./createPaginationUrl";

const RelativeLinkTags: React.FC<{
  currentPage: number;
  pageInPath?: boolean;
  totalPages: number;
}> = ({ currentPage, pageInPath, totalPages }) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const query = parse(searchParams?.toString() || "");
  const path = pathname || "";
  const domain = useDomain();

  const prevUrl = createPaginationUrl(
    path,
    query,
    pageInPath,
    currentPage > 2 ? currentPage - 1 : undefined,
  );

  const nextUrl = createPaginationUrl(path, query, pageInPath, currentPage + 1);

  return (
    <Head>
      {/* SEO: All pages that can possibly be paginated should have these tags */}
      {currentPage > 1 && <link rel="prev" href={`${domain}${prevUrl}`} />}
      {currentPage < totalPages && (
        <link rel="next" href={`${domain}${nextUrl}`} />
      )}
    </Head>
  );
};

export default RelativeLinkTags;
